import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';

import { ConfirmDialog } from '../common';
import { useStyles } from '../styles/consolidated-billing';

export const DisableConsolidatedBillingDialog = ({
  onConfirm,
  onDecline,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useStyles();

  return (
    <ConfirmDialog
      name="disable-consolidated-billing"
      dialogClassName={classes.customSizeModal}
      onConfirm={onConfirm}
      onDecline={onDecline}
      title={i18n.getString(_TL_('Disable consolidated billing'))}
      content={i18n.getString(_TL_(`If you disable consolidated billing,
      we’ll store your settings and generate stand-alone monthly invoices for any account that uses monthly invoices as a payment option.`))}
      confirmButtonText={i18n.getString(_TL_('Disable'))}
      declineButtonText={i18n.getString(_TL_('Cancel'))}
    />
  );
};

DisableConsolidatedBillingDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
};
DisableConsolidatedBillingDialog.defaultProps = {
};
